<template>
  <div id="app">
    <form class="row gy-3" v-on:submit.prevent="submitNewSearch">
      <div class="col-md-3">
        <div class="row">
          <div class="col-12">
            <h3>Suchbegriff</h3>
          </div>
          <div class="col-12">
            <input type="text" v-model="searchText" class="input-item form-control" placeholder="Egal"
                   @keyup="submitNewSearch">
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="col-12">
          <h3>Wann</h3>
        </div>
        <div class="col-12">
          <Datepicker class="datepicker" v-model="searchDate" locale="de" cancelText="Abbrechen" selectText="Auswählen"
                      :enable-time-picker="false" range :partial-range="true"
                      @update:modelValue="submitNewSearch" :format="dateFormat"></Datepicker>
        </div>
      </div>
      <div class="col-md-3">
        <div class="col-12">
          <h3>Veranstaltungsort</h3>
        </div>
        <div class="col-12">
          <input type="text" v-model="searchPlace" class=" form-control input-item" placeholder="Egal"
                 @keyup="submitNewSearch">
        </div>
      </div>
      <div class="col-md-3">
        <div class="col-12">
          <h3>Kategorie</h3>
        </div>
        <div class="col-12">
          <select class="form-select input-item h-100" v-model="searchCategory" @change="submitNewSearch"
                  aria-label="Veranstaltungsart auswählen">
            <option value="Alle" selected>Alle</option>
            <option :value="elem.id" v-for="elem in categoriesObj" v-bind:key="elem.id">{{ elem.name }}</option>
          </select>
        </div>
      </div>
    </form>
    <div class="schnellFilter mt-4 d-lg-flex justify-content-lg-start">
<!--      <div class="titel">-->
<!--        <h5>Schnellfilter</h5>-->
<!--      </div>-->
     
<!--        <span class="badge rounded-pill " @click="fastDateToday">Heute</span>-->
<!--      -->
<!--      -->
<!--        <span class="badge rounded-pill " @click="fastDateTomorrow">Morgen</span>-->
<!--      -->
<!--      -->
<!--        <span class="badge rounded-pill" @click="fastDateAfterTomorrow">Übermorgen</span>-->
<!--      -->
<!--      -->
<!--        <span class="badge rounded-pill" @click="fastDateNextWeek">Nächste Woche</span>-->
<!--      -->
<!--      -->
<!--        <span class="badge rounded-pill " @click="fastDateThisMonth">Dieser Monat</span>-->
<!--      -->
<!--      -->
<!--        <span class="badge rounded-pill" @click="fastDateNextMonth">Nächster Monat</span>-->
<!--      -->
<!--      -->
        <span class="badge rounded-pill red" @click="clearAll">Alle Filter zurücksetzen</span>
      
    </div>
    <hr class="mt-4 mb-4">
    <div class="row gy-3" :v-show="agendaObj && agendaObj.length">
      <div class="col-lg-4" v-for="elem in agendaObj" v-bind:key="elem">
        <article class="agenda_item">
          <a :href="elem.url" class="agenda_link">
            <div class="agenda_image ratio ratio-16x9" >
              <img class="img-fluid object-fit-cover object-position-center" v-if="elem.image" :src="elem.image" alt="">
            </div>
            <div class="agenda_description">
              <div class="agenda_theme">{{ elem.type }}</div>
              <div class="agenda_title">
                <h3>{{ elem.name }}</h3>
              </div>
              <div class="agenda_date">
                {{ elem.startDate + " - " + elem.endDate }}
              </div>
              <div class="agenda_location">
                <span class="icon">
                    <i class="fal fa-map-marker-alt"></i>
                </span> {{ elem.place }}
              </div>
            </div>
          </a>
        </article>
      </div>
      <vue-awesome-paginate
          v-show="totalItems > 0"
          :total-items="totalItems"
          :items-per-page="10"
          :max-pages-shown="3"
          v-model="currentPage"
          :on-click="submitSearch"
      />
    </div>
    <div>
      <div v-if="!agendaObj || !agendaObj.length" class="mt-3">
        <h3>Kein Eintrag gefunden</h3>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  setup() {

  },
  props: {},
  data() {
    return {
      agendaObj: null,
      categoriesObj: null,
      isResult: false,
      searchText: '',
      searchDate: ["", ""],
      startDate: '',
      endDate: '',
      searchPlace: '',
      searchCategory: 'Alle',
      searchTerm: '',
      dateFormat: 'dd.MM.yyyy',
      currentPage: 1,
      totalItems: 0,
    }
  },
  computed: {},
  mounted() {
    this.submitSearch();
    axios
        .get("/umbraco/md/agendaFilter/GetCategoryItems")
        .then(response => {
          if (response.data !== false) {
            this.categoriesObj = response.data;
          }
        }).catch(error => {
      console.log(error)
    });

  },
  methods: {
    clearAll: function () {
      this.searchText = '';
      this.searchPlace = '';
      this.searchCategory = '';
      this.searchDate = '';
      this.submitSearch();
    },
    setSearchDate: function (start, end) {
      this.searchDate[0] = start.toDateString();
      this.searchDate[1] = end.toDateString();
    },
    searchWithDate: function (start, end) {
      this.setSearchDate(start, end);
      this.startDate = start.toDateString();
      this.endDate = end.toDateString();
      this.submitSearch();
    },
    fastDateToday: function () {
      this.searchDate = ["", ""];
      const d = new Date();
      d.setDate(d.getDate());
      this.searchWithDate(d, d);
    },
    fastDateTomorrow: function () {
      this.searchDate = ["", ""];
      const d = new Date();
      d.setDate(d.getDate() + 1);
      this.searchWithDate(d, d);
    },
    fastDateAfterTomorrow: function () {
      this.searchDate = ["", ""];
      const d = new Date();
      d.setDate(d.getDate() + 2);
      this.searchWithDate(d, d);
    },
    fastDateNextWeek: function () {
      this.searchDate = ["", ""];
      const dStart = new Date();
      dStart.setDate(dStart.getDate() + 7);
      const dEnd = new Date();
      dEnd.setDate(dEnd.getDate() + 14);
      this.searchWithDate(dStart, dEnd);
    },
    fastDateThisMonth: function () {
      this.searchDate = ["", ""];
      const dStart = new Date();
      dStart.setDate(dStart.getDate());
      const dEnd = new Date();
      dEnd.setMonth(dStart.getMonth() + 1);
      this.searchWithDate(dStart, dEnd);
    },
    fastDateNextMonth: function () {
      this.searchDate = ["", ""];
      const dStart = new Date();
      dStart.setDate(dStart.getDate());
      dStart.setMonth(dStart.getMonth() + 1);
      const dEnd = new Date();
      dEnd.setMonth(dStart.getMonth() + 1);
      this.searchWithDate(dStart, dEnd);
    },
    submitSearch: function () {
      this.searchTerm = "";


      if (this.searchText !== "")
        this.searchTerm += `&searchText=${this.searchText}`;
      if (this.searchDate != null) {
        this.searchTerm += `&startDate=${moment(String(this.searchDate[0])).format("YYYY-MM-DD")}`;
        this.searchTerm += `&endDate=${moment(String(this.searchDate[1])).format("YYYY-MM-DD")}`;
      }
      if (this.searchPlace !== "")
        this.searchTerm += `&searchPlace=${this.searchPlace}`;
      if (this.searchCategory !== "")
        this.searchTerm += `&searchCategory=${this.searchCategory}`;

      var totalItemsReqUrl = `/umbraco/md/agendaFilter/getTotalItemsCount?&currentPage=${this.currentPage}${this.searchTerm}`;
      axios
          .get(totalItemsReqUrl)
          .then(response => {
            if (response.data !== false) {
              this.totalItems = response.data;
              console.log(this.totalItems);
            }
          }).catch(error => {
        console.log(error)
      });

      var reqURL = `/umbraco/md/agendaFilter/getList?&currentPage=${this.currentPage}${this.searchTerm}`;
      axios
          .get(reqURL)
          .then(response => {
            if (response.data !== false) {
              this.agendaObj = response.data;
              this.isResult = true;
            }
          }).catch(error => {
        console.log(error)
      });
    },
    submitNewSearch: function () {
      this.currentPage = 1;
      this.submitSearch();
    },

  }
}
</script>

<style scoped>

</style>